import api from "API/Api"
import React, { useState, useEffect, useRef } from "react"
import { Link } from "react-router-dom"
import { AvForm, AvField } from "availity-reactstrap-validation"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"

const AddDesignation = () => {
  const formRef = useRef(null)
  const [desig, setDesig] = useState([])
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleValidSubmit = async (event, values) => {
    setLoading(true)
    try {
    const addDesig = await api.post("create-designation", values)
    if (addDesig.data.success === true) {
      formRef.current.reset()
      setSubmitted(true)
    }
    } catch (error) {

      // Handled by global interceptor

    }

    setLoading(false)
  }
  return (
    <>
      <div className="dashBody">
        <div className="font-size-18 mb-0 dashHeader">
          <Row>
            <Col md={6}>
              <h4>Add Designation</h4>
            </Col>
            <Col md={6} style={{ textAlign: "right" }}>
              <Link to="/designations" className="dashBtn">
                <i className=" fas fa-chevron-left "></i> <b> Back</b>
              </Link>
            </Col>
          </Row>
        </div>
        <div className="dashContent">
          <AvForm
            style={{ position: "relative" }}
            ref={formRef}
            className="form-horizontal"
            onValidSubmit={(e, v) => {
              handleValidSubmit(e, v)
            }}
          >
            <div className="mb-3">
              <AvField
                name="designation"
                label="Designation"
                value=""
                className="form-control"
                placeholder="Enter Designation"
                type="text"
                required
              />
            </div>

            <div className="mb-3 row mt-4">
              <div className="col-6">
                {submitted ? (
                  <UncontrolledAlert color="success">
                    <strong>Designation is Added!</strong>
                  </UncontrolledAlert>
                ) : null}
              </div>
              <div className="col-6 text-end">
                <button
                  className="btn btn-primary w-md waves-effect waves-light"
                  type="submit"
                      disabled={loading}
                >
                  {loading ? (
                    <>
                      <Spinner animation="border" size="sm" />
                      <span style={{ paddingLeft: "10px" }}>Adding...</span>
                    </>
                  ) : (
                    <span>Add Designation </span>
                  )}
                </button>
              </div>
            </div>
          </AvForm>
        </div>
      </div>
    </>
  )
}

export default AddDesignation
